
(function() {
  const STORAGE_KEY = 'sokhi_wishlist';
  
  function getWishlist() {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  }
  
  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }
  
  function isInWishlist(productId) {
    return getWishlist().some(p => p.id === productId);
  }
  
  function updateUI() {
    const btn = document.getElementById('wishlist-btn');
    if (!btn) return;
    
    const productId = parseInt(btn.getAttribute('data-product-id'));
    const isWished = isInWishlist(productId);
    
    if (isWished) {
      btn.style.backgroundColor = '#D97A9A';
      btn.style.color = 'white';
      btn.style.borderColor = '#D97A9A';
      if (document.getElementById('wishlist-text')) {
        document.getElementById('wishlist-text').textContent = 'In Wishlist';
      }
    } else {
      btn.style.backgroundColor = 'transparent';
      btn.style.color = '#D97A9A';
      btn.style.borderColor = '#D97A9A';
      if (document.getElementById('wishlist-text')) {
        document.getElementById('wishlist-text').textContent = 'Add to Wishlist';
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    updateUI();
    
    const btn = document.getElementById('wishlist-btn');
    if (btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        const productId = parseInt(this.getAttribute('data-product-id'));
        const productTitle = this.getAttribute('data-product-title');
        const productImage = this.getAttribute('data-product-image');
        const productPrice = this.getAttribute('data-product-price');
        
        let wishlist = getWishlist();
        const exists = wishlist.some(p => p.id === productId);
        
        if (exists) {
          wishlist = wishlist.filter(p => p.id !== productId);
          alert(productTitle + ' removed from wishlist!');
        } else {
          wishlist.push({
            id: productId,
            title: productTitle,
            image: productImage,
            price: productPrice,
            addedDate: new Date().toISOString()
          });
          alert(productTitle + ' added to wishlist!');
        }
        
        saveWishlist(wishlist);
        updateUI();
      });
    }
  });
})();
